import request from '../Functions/ajax/request'

export default async function CommandeLoader ({ params })
{
	return { params, page: getPage({ params }) };
}

async function getPage ({ params })
{
	try
	{
		var response = await request('/commandes/get-commande')
		.config({ })
		.post({ text_number: params.text_number });

	}
	catch (e)
	{
		response = undefined;
	}

	if (!response?.data)
	{
		const keyword = params.text_number?.startsWith?.('D')
		? 'Devis'
		: 'Commande';

		throw { error: keyword + ' introuvable.' };
	}

	return { commande: response.data };
}